<template>
  <div class="login-content cg-page">
    <Header></Header>
    <div class="login">
      <div class="home-prize ac">
        <img style="width: 70%" src="../../static/images/login_tip.png"/>
      </div>
      <div class="landing-page">
        <div class="input-div">
          <div class="span mt10 fs33 crfff fw7" style="font-weight: 400;margin-bottom: 15px;">{{$t('phoneNumber')}}</div>
          <div class="input-item">
            <div class="input-item2">
              <span class="app-en num_09"></span>
              <input style="height: 100px;color: black;font-size: 55px" class="input" v-model="mobile" type="number" placeholder="">
            </div>
          </div>
        </div>
        <div class="input-div">
          <div class="input-item" style="background: none;">
            <div class="input-item2 input-otp disflex">
              <input class="input-item input" v-model="otp" ref="getFocus2" maxlength="4" type="number" style="width: 100%;" placeholder="">
              <button class="btn btn-red" style="padding: 0 10px;margin-left:5px;font-size: 30px;" :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')" @click="getSendOtp">{{codeText}}</button>
            </div>
          </div>
        </div>

        <div class="drown-list login-list" style="width: 100%;margin-top: 100px">
          <div class="disflex" style="background:none;box-shadow: none;">
            <div style="width: 55%"  class="land-btn day_btn" @click="goLogin">
              <span class="day">{{ $t('Login') }}</span>
            </div>
          </div>
        </div>

        <div class="ac otp-b disflex crfff mt100">
          <div class="icon icon2" style="color: white;" @click="getType('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>
          <div class="icon icon2" style="color: white;" @click="getType('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
import Header from '../components/HeaderTwo'
import CryptoJS from '../../static/js/crypto-js.min.js'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        type:'',
        password:'',
        otp:'',
        codeText:'',
        isReturn:false,
        isEN:'bur'

      }
    },
    watch: {
			otp(now,old) {
				let that = this;
				that.$nextTick(function() {
					if(now.length==4||old==now){
						that.timer = setTimeout(() => {
							that.$refs.getFocus2.blur();
						}, 100);
					}
				});
			},
		},
	created(){
    this.codeText = this.$t('getCode')
    if (this.$route.query.msidn){
      let ss = this.aesEcbDecrypt(this.$route.query.msidn);
      this.mobile = this.dealPhone_2(ss);
      this.getSendOtp();
    }
	},
    methods: {
      getType(type){
          this.$router.push({path:'/'+type,query:{type:type}});
      },
      back(){
        this.$router.go(-1);
      },
      getSendOtp(){
        let that = this
        if(that.isReturn){
          return;
        }
        that.isReturn = true
        let mobile = '09' + that.mobile
        mobile = that.dealPhone(mobile)
        let encrypt_mobile = that.aesEcbEncrypt(mobile);
        let data ={
            'msidn':encrypt_mobile
        }
        that.$api.post('/api/user/login_send_otp',data,r =>{
          that.$utils.alertText(r.msg,80,3000);
          this.countDown(61,1)
        })
      },
      goLogin(){
        let that = this
        if(that.mobile==''){
        	that.$utils.alertText(that.$t('loginTips'),80)
        	return;
        }
        const userAgent = navigator.userAgent;
        const deviceId = this.getDeviceId();
        let mobile = '09' + that.mobile
        mobile = that.dealPhone(mobile)
        let encrypt_mobile = that.aesEcbEncrypt(mobile);
        let data ={
          'mobile':encrypt_mobile,
          'otp':this.otp,
          'user_agent': userAgent,
          'device_id': deviceId
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/user/otp_login',data,r =>{
          that.$parent.loadModal(false);
          if(r.code==1){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            that.isShowlogin = false
            that.mobile = ''
            that.otp = ''
            this.$router.push({path:'/'})
          }else{
            that.$utils.alertText(r.msg,80);
          }
        })
      },
      // 计时
      countDown (miao,type){
      	if(miao === 1){
      		this.codeText = this.$t('getCode');
      		return;
      	}
      	miao--;
      	if(type === 1){
      		this.codeText = miao + "s";
          this.isReturn = false
      	}
      	setTimeout(() =>{
      		this.countDown(miao,type);
      	},1000)
      },
      //解密
      aesEcbDecrypt(ciphertextBase64) {
        try {
          const key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
          const encrypted = CryptoJS.enc.Base64.parse(ciphertextBase64);
          const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encrypted },
            key,
            {
              mode: CryptoJS.mode.ECB,
              padding: CryptoJS.pad.NoPadding
            }
          );
          return decrypted.toString(CryptoJS.enc.Utf8).replace(/\0+$/, "");
        } catch (e) {
          console.error("AES 解密失败:", e);
          return "";
        }
      },
      //加密
      aesEcbEncrypt(plaintext) {
        var key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
        var data = CryptoJS.enc.Utf8.parse(plaintext);
        var blockSize = 16;
        var padLen = (blockSize - (data.sigBytes % blockSize)) % blockSize;
        var words = data.words.slice(0);
        var wordArray = CryptoJS.lib.WordArray.create(words, data.sigBytes + padLen);
        var encrypted = CryptoJS.AES.encrypt(wordArray, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.NoPadding
        });
        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
      },
      dealPhone_2(phone) {
        phone = phone.replace(/\s+/g, ''); // 移除所有空格
        if (phone.startsWith('97') && phone.length === 10) {
          phone = phone.substring(1);
        }
        return phone;
      },
      dealPhone(phone) {
        phone = phone.replace(/\s+/g, ''); // 移除所有空格
        if (phone.startsWith('0909') && phone.length === 13) {
          phone = phone.substring(3);
        }
        if (phone.startsWith('09') && phone.length === 11) {
          phone = phone.substring(1);
        }
        if (phone.startsWith('099') && phone.length === 12) {
          phone = phone.substring(2);
        }
        return phone;
      },
      getDeviceId() {
        let id = localStorage.getItem('device_id');
        if (!id) {
          id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
          localStorage.setItem('device_id', id);
        }
        return id;
      },
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .otp-b{justify-content: space-evenly;}
</style>



// WEBPACK FOOTER //
// src/page/otp.vue